import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Route, Router } from '@angular/router';
import { routes as ROUTES } from '../app-routing.module';

@Injectable({
  providedIn: 'root'
})
export class RouterService {

  private previousUrl?: string;
  private currentUrl?: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.currentUrl = this.router.url;
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
      };
    });
  }



  public getPreviousUrl() {
    console.log(this.activatedRoute)
    return this.previousUrl;
  }
}
